const round = (value, digits = 2) => {
    const factor = Math.pow(10, digits);
    return Math.round(value * factor) / factor;
};
export { round, };
